import React, { useEffect, useState, useRef } from "react";
import {
  Alert as MuiAlert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  CardContent,
  DialogActions,
  CircularProgress,
  TextField as MuiTextField,
  Grid,
  Alert,
  CardHeader,
  Typography,
  MenuItem,
  Button,
} from "@mui/material";
import SaveCancel from "../../../components/SaveCancel";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import useComplaint from "../../../hooks/useComplaint";
import { useNavigate, useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import useAuth from "../../../hooks/useAuth";

const validationSchema = Yup.object().shape({
  authUser: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    })
    .nullable()
    .required(),

  // comments: Yup.string().required("Required"),
});

const currentPayload = {
  filters: [
    {
      fieldName: "businessTypes",
      fieldValue:
        "EMPL,ADMIN,NETWORK_ADMIN,NETWORK_ENGINEER,FIBER_ADMIN" +
        ",FIBER_ENGINEER,HELPER,ACCOUNT_ADMIN,ACCOUNT_EXECUTIVE," +
        "TELECALLER,SALES_ADMIN,SALES_EXECUTIVE",
      op: "in",
      dataType: "string",
      isJoin: true,
      attributeName: "businessTypes",
    },
  ],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const AssignUser = (props) => {
  const { unSetDialog } = useDialog();

  const { t } = useTranslation();
  const { getCustomerComplaint, customerComplaint, assignComplaint, isSubmitting } = useComplaint();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [userPayload, setUserPayload] = useState(currentPayload);
  const { autoSearchAuthUser, authUserAutoSearchResults } = useAuth();

  const { complaintId, customerComplaintId, fetchData } = props;

  React.useEffect(() => {
    if (Object.keys(customerComplaint).length !== 0) {
      const initialValues = {
        complaintId: complaintId,
        customerComplaintId: customerComplaintId,
        authUser: {
          label: customerComplaint?.authUser?.name,
          value: customerComplaint?.authUser?.id,
        },
      };
      reset(initialValues);
    }
  }, [customerComplaint]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const { state } = useLocation();
  console.log(state, "location");

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
  } = methods;
  const [userOptions, setUserOptions] = useState([]);

  const onSubmit = async (data) => {
    try {
      data["authUser"] = {
        id: data.authUser.value,
        name: data.authUser.label,
      };
      console.log(data, "new data changes");
      await assignComplaint(data);

      dispatch(showSuccessSnackbar("Assigned successfully!"));
      unSetDialog("Assign");
      fetchData();
    } catch (err) {
      console.log(err, "ddddddddddddd");
      dispatch(showErrorSnackbar("Failed to assign "));
    }
  };
  const cancelBtn = () => {
    navigate("/complaints/list");
  };

  const fetchUser = async () => {
    await autoSearchAuthUser(userPayload);
  };
  useEffect(() => {
    fetchUser();
  }, [userPayload]);

  const fetch = async () => {
    await getCustomerComplaint(customerComplaintId);
  };

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (authUserAutoSearchResults && authUserAutoSearchResults.data.length !== 0) {
      const results = [...userOptions, ...authUserAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setUserOptions(filteredResults);
    }
  }, [authUserAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <SearchableAutoComplete
                label={t("assign_to_user")}
                name="authUser"
                data={userOptions}
                control={control}
                payload={userPayload}
                setPayload={setUserPayload}
                loading={false}
                fullWidth
                variant="outlined"
                errors={errors}
                multiple={false}
                defaultValue={""}
                hasNextPage={false}
                fields={validationSchema.fields}
              />
            </Grid>

            {/* <Grid item xs={9.5} sm={12} md={6} lg={6} xl={6}>
              <CustomTextField
                label={t("comments")}
                name="comments"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                rows={1}
                multiline={true}
                fields={validationSchema.fields}
              />
            </Grid> */}
          </Grid>
          <DialogActions>
            <Button
              disabled={isSubmitting}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
            >
              Assign
            </Button>

            <Button variant="text" onClick={() => unSetDialog("Assign")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default AssignUser;
